import React from "react";
import Icon from "../../assets/icons/Icon";
import TooltipPopup from "../Tooltip/TooltipPopup";
import { isMobile as CheckIfIsMobile } from "../../utils/CheckIf";
import GetUser from "../../utils/UserFunctions/GetUser";
import injectSheet, { withTheme } from "react-jss";
import classNames from "classnames";

const InformationInfo = (props) => {
  const { classes, className, theme } = props;
  const i =
    props.informations &&
    props.informations.find((x) => x.property === props.name);

  if (CheckIfIsMobile.any() || !i) return null;
  let infoText =
    props.hasValue && i.filledInfo
      ? i.filledInfo
      : props.isKultur && i.kulturInfo
      ? i.kulturInfo
      : props.isAfv && i.afvInfo
      ? i.afvInfo
      : i.info;
  if (!infoText) return null;

  if (infoText.includes("[*****stf]")) {
    const forbundNamn = GetUser().forbund.namn;
    infoText = infoText.replace("[*****stf]", forbundNamn);
    const namn = (forbundNamn + "s").replace("ss", "s");
    infoText = infoText.replace("[*****stf+s]", namn);
  }

  const hasHTML = infoText.includes("<");

  return (
    <div
      className={classNames(classes.info, className)}
      data-tooltip-content={hasHTML ? "" : infoText}
      data-tooltip-html={hasHTML ? infoText : ""}
      data-tooltip-id={props.name === "stim2" ? "stim2" : "top"}
      data-tooltip-variant="dark"
    >
      <Icon
        fill={theme ? theme.themeColor : "#335cda"}
        width="18px"
        type="info"
      />
      {props.tooltipId && (
        <TooltipPopup
          parent={props.tooltipId}
          clickable={props.name === "stim2"}
        />
      )}
    </div>
  );
};
const styles = {
  info: {
    marginLeft: (props) => (props.marginLeft ? props.marginLeft : "6px"),
    "& svg": {
      display: "block",
      pointerEvents: "none",
    },
  },
};
export default withTheme(injectSheet(styles)(InformationInfo));
